<template>
  <div class="MerTokerLjje">
    <div class="center">
      <div class="ctdiv" v-for="(item,index) in commssionList" :key="index">
        <div style="font-weight:bold;font-size: 15px;">您通过{{ item.typeName }}的方式获得{{ item.totolMoney }}元红包</div>
        <div style="font-size: 14px;color:#4D4D4D;margin-top: 2vh;">
          获得时间:{{ item.addTime }}
          <span style="float:right">+{{ item.totolMoney }}元</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MerTokerLjje',
  data () {
    return {
      commssionList: [],
      queryData: {},
    }
  },
  created () {
    this.queryData = this.$route.query
    this.getData()
  },
  methods: {
    getData () {
      this.$api.post({
        url: '/merchant/api/activity/spread-list/find/give-red-paper/list',
        data: {
          activityType: this.queryData.activityType,
          merId: this.queryData.merId,
          activityId: this.queryData.activityId,
          storeId: this.queryData.storeId,
          fansid: this.queryData.fansid,
          uid: this.queryData.uid
        },
        login: false
      }).then(res => {
        if (res.data != null) {
          this.commssionList = res.data
        }
      })
    },
  }
}
</script>
<style scoped>
.MerTokerLjje {
  margin-top: 50px;
  background: rgba(239, 239, 239, 1);
}

.center {
  margin-top: 3vh;
  padding: 5vw;
  width: 100%;
  background-color: rgba(239, 239, 239, 1);
}

.ctdiv {
  margin-top: 2vh;
  padding: 2vw;
  width: 86vw;
  background-color: white;
  border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/active/MerTokerLjje.vue